const urlSafeBase64Map = {
  '+': '-',
  '/': '_',
  '=': '',
}

export const encodeUrlSafeBase64 = data => btoa(data).replace(/[+/=]/g, m => urlSafeBase64Map[m])

export { encodeUrlSafeBase64 as default };
